<template>
  <div class="d-flex align-items-center px-gd-half">
    <svg
      width="72"
      height="32"
      viewBox="0 0 72 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 2C0 0.895431 0.895431 0 2 0H70C71.1046 0 72 0.895431 72 2V30C72 31.1046 71.1046 32 70 32H2C0.895431 32 0 31.1046 0 30V2Z"
        fill="#F8F9FA"
      />
      <path
        d="M40 12H43V21.5C43 22.1875 42.75 22.7812 42.25 23.2812C41.75 23.7812 41.1875 24 40.5 24H31.5C30.8125 24 30.2188 23.7812 29.7188 23.2812C29.2188 22.7812 29 22.1875 29 21.5V12H32C32 11.2812 32.1562 10.625 32.5312 10C32.875 9.375 33.3438 8.90625 33.9688 8.53125C34.5938 8.1875 35.25 8 36 8C36.7188 8 37.375 8.1875 38 8.53125C38.625 8.90625 39.0938 9.375 39.4688 10C39.8125 10.625 40 11.2812 40 12ZM36 9.5C35.3125 9.5 34.7188 9.75 34.2188 10.25C33.7188 10.75 33.5 11.3125 33.5 12H38.5C38.5 11.3125 38.25 10.75 37.75 10.25C37.25 9.75 36.6875 9.5 36 9.5ZM41.5 21.5V13.5H40V14.75C40 14.9688 39.9062 15.1562 39.7812 15.2812C39.625 15.4375 39.4375 15.5 39.25 15.5C39.0312 15.5 38.8438 15.4375 38.7188 15.2812C38.5625 15.1562 38.5 14.9688 38.5 14.75V13.5H33.5V14.75C33.5 14.9688 33.4062 15.1562 33.2812 15.2812C33.125 15.4375 32.9375 15.5 32.75 15.5C32.5312 15.5 32.3438 15.4375 32.2188 15.2812C32.0625 15.1562 32 14.9688 32 14.75V13.5H30.5V21.5C30.5 21.7812 30.5938 22.0312 30.7812 22.2188C30.9688 22.4062 31.2188 22.5 31.5 22.5H40.5C40.75 22.5 41 22.4062 41.1875 22.2188C41.375 22.0312 41.5 21.7812 41.5 21.5Z"
        fill="#6E7881"
      />
    </svg>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
